import React, { useState } from "react";
import styled from "@emotion/styled";
import { MoonLoader } from "react-spinners";
import { connect } from "react-redux";
import Slider from "./Slider";

const select = ({ interactiveMap }) => ({
  blogIndexInView: interactiveMap.blogIndexInView - 1
});

function Gallery({ events, blogIndexInView }) {
  return (
    <Container>
      {events.map((event, i) => (
        <SliderWrapper hide={i !== blogIndexInView}>
          <Slider>
            {event.images.map(src => (
              <GalleryImage src={src} />
            ))}
          </Slider>
        </SliderWrapper>
      ))}
    </Container>
  );
}

export default connect(select)(Gallery);

const Container = styled.div`
  // overflow: hidden;
`;

const SliderWrapper = styled.div`
  display: ${({ hide }) => (hide ? "none" : "block")};
`;

function GalleryImage({ src }) {
  return <Image src={src} />;
}

const Image = styled.img`
  width: 100%;
  object-fit: cover;
  @media (max-width: 600px) {
    height: calc(100vw / 1.5);
  }
`;

export function LoadingAnimation({ active }) {
  return (
    <LoadingWrapper active={active}>
      <MoonLoader
        sizeUnit={"px"}
        size={30}
        color={"turquoise"}
        loading={active}
      />
    </LoadingWrapper>
  );
}

const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: white;
  display: ${({ active }) => (active ? "flex" : "none")};
`;
